import EditIcon from './edit-icon';
import {PageBaseComponent} from './page-components';
import {CarouselItem,BasicCarousel,CarouselIndicators} from '../components/carousel';
import {MediaManagerController} from './media-manager';
import JsUtility from '../utils/utility';

export default class CarouselComponent extends PageBaseComponent{
    constructor(props){
        super(props)
        this.renderCount=-1;
    }

    componentDidMount(){
        super.componentDidMount();
    }

    onFilesSelected(files){
        this.state.component.content.media=files;
        this.setState(this.state.component);
    }

    onFilesCancel(){

    }

    onEditClick(event){
        this.mediaController.mode='multi-select';
        this.mediaController.show(this.state.component.content.media);
    }

    onIndicatorClick(index){
        this.basicCarousel.slideByIndex(index);
    }

    onSlide(index){
        this.carouselIndicators.update(index);
    }

    onNextArrowClick() {
        this.basicCarousel.clearInterval();
        this.basicCarousel.slideNext();
    }

    onPrevArrowClick() {
        this.basicCarousel.clearInterval();
        this.basicCarousel.slidePrev();
    }

    
    render(){
        var auto=false;
        this.renderCount+=1;
        if(this.props.auto && this.renderCount < 1) auto=true;
        var nodes = this.state.component.content.media.map((file)=> {
            var fileUrl=file.url + '?width=2200';
            var mobileFileUrl=JsUtility.toMobileUrl(file.url);
            if(file.meta && file.meta.toLowerCase()==='video' && file.link){
                return(
                    <CarouselItem video={true} key={this.randomId} gradient={this.props.gradient}>
                       <picture>
                         <source media="(min-width: 641px)" srcSet={fileUrl} />
                         <source media="(max-width: 640px)" srcSet={mobileFileUrl} />
                         <img src={fileUrl} />
                       </picture> 
                       <video className="carousel-player" controls>
                          <source src={file.link} type="video/mp4" />
                       </video>
                    </CarouselItem>
                );
            }else{
                return(
                    <CarouselItem key={this.randomId} link={file.link}>
                       <picture>
                         <source media="(min-width: 641px)" srcSet={fileUrl} />
                         <source media="(max-width: 640px)" srcSet={mobileFileUrl} />
                         <img src={fileUrl} />
                       </picture> 
                    </CarouselItem>
                );
            }
        });
        var indicatorCount=nodes.length;
        var interval=this.props.interval;
        if(!interval) interval=3000;
        var postUrl='/api/MediaFile';
        if(this.props.postUrl) postUrl=this.props.postUrl;
        let showIndicators=true;
        if(this.props.hideIndicators) showIndicators=false;
        let cls ='image-container carousel-image-container';
        if(this.props.cssClass) cls += ' ' + this.props.cssClass;
        return(
           <div>
              <section className={cls}>
                  <BasicCarousel auto={auto} interval={interval} ref={(ref) => this.basicCarousel = ref} onSlide={this.onSlide.bind(this)}>
                      {nodes}
                  </BasicCarousel>
                  <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active} cls={this.props.iconCss}>
                     <MediaManagerController
                        postUrl={postUrl} 
                        data={this.props.mediaManagerData} 
                        ref={(ref) => this.mediaController = ref} 
                        onFilesSelected={this.onFilesSelected.bind(this)} 
                        onCancel={this.onFilesCancel.bind(this)} 
                        
                      />
                  </EditIcon>
                  {this.props.showArrows && 
                     <carousel-navigation class="prev nav-visible" tabIndex="0" onClick={this.onPrevArrowClick.bind(this)}></carousel-navigation>
                  }
                  {this.props.showArrows && 
                     <carousel-navigation class="next nav-visible" tabIndex="0" onClick={this.onNextArrowClick.bind(this)}></carousel-navigation>
                  }
              </section>
              {showIndicators && indicatorCount > 1 && 
              <CarouselIndicators 
                 ref={(ref) => this.carouselIndicators = ref} 
                 count={indicatorCount} 
                 activeIndex="0" 
                 onClick={this.onIndicatorClick.bind(this)} 
              /> }
           </div> 
        );
    }
}